



































import {Component, Mixins} from 'vue-property-decorator'
import {
  Modal,
  IModal,
  IModalStepData
} from '@/entities'
import ModalBase from '../ModalBase.vue'
import StepChain from '../StepChain.vue'
import modalBaseMixin from '@/mixins/modal/modalBaseMixin'
// steps
const ModalConsultationConfig = () => import('./ModalConsultationConfig.vue')
const ModalConsultationPerson = () => import('./ModalConsultationPerson.vue')
const ModalConsultationEmail = () => import('./ModalConsultationEmail.vue')
const ModalConsultationMessage = () => import('./ModalConsultationMessage.vue')
const ModalConsultationCheck = () => import('./ModalConsultationCheck.vue')
const ModalConsultationDone = () => import('./ModalConsultationDone.vue')

@Component({
  name: 'ModalConsultation',
  components: {
    ModalBase,
    StepChain,
    ModalConsultationConfig,
    ModalConsultationPerson,
    ModalConsultationEmail,
    ModalConsultationMessage,
    ModalConsultationCheck,
    ModalConsultationDone,
  }
})
export default class ModalConsultation extends Mixins(modalBaseMixin) {

  protected getModal(initSubject: any, initStep?: string, specific?: boolean): IModal {
    let initSteps: IModalStepData[] = specific ? [] : [
      {
        name: 'config',
        controls: [
          {
            type: 'cancel',
            primary: false
          }, {
            type: 'next'
          }
        ]
      }
    ];
    let quizSteps: IModalStepData[] = initSubject?.is_quiz_required ? [
      {
        name: 'message',
        controls: [
          {
            type: 'next'
          }
        ]
      }
    ] : [];
    return new Modal({
      name: () => this.$t('modals.titles.consultation') as string,
      close: this.$storage.actions.closeModal,
      stepName: initStep,
      subject: initSubject,
      steps: [
        ...initSteps,
        {
          name: 'person',
          controls: [
            {
              type: specific ? 'cancel' : 'back',
              primary: false
            }, {
              type: 'next'
            }
          ]
        }, {
          name: 'email',
          controls: [
            {
              type: 'reset',
              label: 'ok',
              primary: false
            }, {
              type: 'ok',
              label: 'order-details'
            }
          ]
        },
        ...quizSteps,
        {
          name: 'check',
          controls: [
            {
              type: 'next'
            }
          ]
        }, {
          name: 'done',
          silent: true,
          controls: [
            {
              type: 'ok'
            }
          ]
        }
      ]
    });
  }

}
